import { Box, Typography } from "@mui/material";

const InfoBox = ({ label, children, sx, containerSx, flex }) => {
  return (
    <Box
      sx={{
        border: "1px solid #ccc",
        position: "relative",
        width: "100%",
        ...containerSx,
      }}
      flex={flex ? flex : 1}
    >
      <span
        style={{
          position: "absolute",
          top: "-7px",
          left: "10px",
          fontSize: "12px",
          backgroundColor: "#fff",
          color: "#a0a0a0",
          ...sx,
        }}
      >
        &nbsp; {label} &nbsp;
      </span>
      <Box
        sx={{
          padding: "5px",
          paddingTop: "10px",
          fontSize: "10px",
          whiteSpace: "wrap",
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default InfoBox;
